import { z } from 'zod';
import { SipTrunkSchema } from '../types/trunk';

export const SipTrunkSaveOutcomeSchema = z.discriminatedUnion('state', [
  z.object({
    state: z.literal('saved_only'),
    reason: z.enum(['created', 'testing']),
  }).strict(),
  z.object({
    state: z.literal('command_accepted'),
    operation: z.enum(['reload', 'disable']),
  }).strict(),
  z.object({
    state: z.literal('not_applied'),
    reason: z.enum(['not_connected', 'configuration_error', 'node_unavailable', 'tenant_unavailable', 'command_rejected']),
  }).strict(),
  z.object({
    state: z.literal('unconfirmed'),
    reason: z.enum(['timeout', 'unexpected_response', 'command_error']),
  }).strict(),
]);

export type SipTrunkSaveOutcome = z.infer<typeof SipTrunkSaveOutcomeSchema>;

export const SipTrunkSaveResponseSchema = SipTrunkSchema.pick({ id: true, status: true })
  .extend({ freeswitch_update: SipTrunkSaveOutcomeSchema })
  .passthrough();

export type SipTrunkSaveResponse = z.infer<typeof SipTrunkSaveResponseSchema>;
